import type { KeywordPin } from './types';

/** The first enabled pin whose keyword the text starts with, case-insensitively. */
export function matchKeywordIn(pins: ReadonlyArray<KeywordPin>, text: string): KeywordPin | null {
	const normalized = text.toLowerCase().trim();
	if (!normalized) {
		return null;
	}
	return pins.find(pin => pin.enabled && pin.keyword && normalized.startsWith(pin.keyword.toLowerCase())) ?? null;
}
